import AppSettings from '../../../AppSettings';
// Librairies
import i18n from '../../../locales/i18n';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export const eventHandlers = {
    // Aucun id local envoyé : l'API attribue l'id de l'évènement, ses liens n'ont pas d'id propre (clé évènement + élément)
    'event.create': {
        describe: () => i18n.t("Ajout d'un évènement"),
        buildRequest: async (op) => {
            const { projectEvent } = op.payload;
            return {
                request: {
                    method: 'post', url: `${BACKEND_ENDPOINT}events/`,
                    data: { ...projectEvent, id: 0, projectEventElements: (projectEvent.projectEventElements || []).map(({ projectEventId, ...pee }) => pee) }
                }
            };
        },
        onSuccess: async (op, response, context) => {
            await context.idMap.set('event', op.target.id, response.data.id);
            return { projectEvent: response.data, localId: op.target.id };
        }
    },
    // Relecture avant l'envoi : seuls la date et le commentaire saisis remplacent ceux du serveur (les seuls que l'API recopie)
    'event.update': {
        describe: () => i18n.t("Modification d'un évènement"),
        buildRequest: async (op, context) => {
            const eventId = await context.idMap.resolve('event', op.target.id);
            const current = await context.request({ method: 'get', url: `${BACKEND_ENDPOINT}events/projectEvents/${op.projectId}` });
            const serverEvent = (current.data || []).find(projectEvent => projectEvent.id === eventId);
            if (!serverEvent) return { discard: true, reason: 'deleted_on_server' };
            return {
                request: {
                    method: 'put', url: `${BACKEND_ENDPOINT}events/`,
                    data: { projectEvent: { ...serverEvent, ...op.payload.changes, id: eventId }, peeToAdd: op.payload.peeToAdd, peeToRemove: op.payload.peeToRemove }
                }
            };
        },
        onSuccess: async (op, response) => ({ projectEvent: response.data })
    },
    'event.delete': {
        describe: () => i18n.t("Suppression d'un évènement"),
        buildRequest: async (op, context) => ({ request: { method: 'delete', url: `${BACKEND_ENDPOINT}events/${await context.idMap.resolve('event', op.target.id)}` } }),
        onSuccess: async () => ({}),
        // Évènement déjà supprimé ailleurs
        isAlreadyDone: (error) => error?.response?.status === 404
    },
    'event.updateElements': {
        describe: () => i18n.t("Commentaire d'un élément d'évènement"),
        buildRequest: async (op, context) => {
            const eventId = await context.idMap.resolve('event', op.payload.projectEventId);
            const projectEventElements = op.payload.projectEventElements.map(pee => ({ ...pee, projectEventId: eventId }));
            return { request: { method: 'put', url: `${BACKEND_ENDPOINT}events/updateProjectEventElements/?projectId=${op.projectId}&projectEventId=${eventId}`, data: projectEventElements } };
        },
        onSuccess: async (op, response) => ({ projectEventElements: response.data }),
        // Évènement ou liaison retirés entre-temps
        isAlreadyDone: (error) => error?.response?.status === 404
    }
};
